<template>
  <section class="flex flex-col sm:flex-row w-full justify-between sm:items-center">
    <div class="w-full sm:w-auto px-6 mt-2">
      <div class="flex gap-2 items-center">
        <h5 class="text-base sm:text-lg">{{ material?.name }}</h5>
        <button
          v-if="
            typeModalHeader === _typeModalHeader.TEACHER_TRADITIONAL_COURSE &&
            user?.role === 'TEACHER'
          "
          class="btn-simple justify-start"
          @click="onGoToEditObject()"
        >
          <v-icon name="hi-solid-pencil"></v-icon>
        </button>
      </div>
      <div
        class="flex flex-col sm:flex-row sm:space-x-2 mt-1"
        v-if="typeModalHeader !== _typeModalHeader.TEACHER_TRADITIONAL_COURSE"
      >
        <p class="text-sm font-sm capitalize whitespace-nowrap">
          {{
            $t("labels.generic", {
              pt: `Classificação: ${getLearningGroupTypePT(material?.learningGroupType)} |`,
              en: `Classification: ${material?.learningGroupType} |`,
            })
          }}
        </p>
        <TagMaterials :material="material" />
      </div>
      <div
        class="flex flex-row gap-4 mt-2"
        v-if="
          typeModalHeader === _typeModalHeader.TEACHER_TRADITIONAL_COURSE &&
          user?.role === 'TEACHER'
        "
      >
        <Button
          class="btn-delete flex gap-1 items-center"
          :loading="loading"
          @click="onDeleteObject()"
        >
          <v-icon class="-ml-5" name="md-delete" scale="0.8"></v-icon>
          <p class="text-[12px]" v-if="loading">Descartando...</p>
          <p class="text-[12px]" v-else>Descartar objeto</p>
        </Button>
      </div>
    </div>
    <div class="flex justify-between sm:justify-end items-center w-full sm:w-auto px-6 sm:px-0 mt-4 sm:mt-0 sm:gap-4">
      <Button
        class="btn-primary"
        icon="pi pi-chevron-left"
        :disabled="indexMaterial == 0"
        @click="onChooseMaterial(-1)"
      />
      <Button
        class="btn-primary"
        icon="pi pi-chevron-right"
        @click="onChooseMaterial(1)"
        :disabled="indexMaterial == maxIndexMaterial"
      />
    </div>
  </section>
</template>

<script lang="ts">
import {
  MaterialLearningGroupType,
  MaterialType,
} from "@/models/material.model";
import { TypeModalHeader } from "@/models/material.model";
import { User } from "@/models/user.model";
import { getUserFromStorage } from "@/utils/user-store.util";
import { defineComponent, PropType } from "vue";
export default defineComponent({
  name: "headerTeacherMaterials",
  emits: ["onChooseMaterial", "onGoToEditObject", "onDeleteObject"],
  watch: {
    material() {
      this.loading = false;
    },
  },
  props: {
    material: {
      type: Object as PropType<any>,
    },
    indexMaterial: {
      type: Number as PropType<number>,
      default: 0,
    },
    maxIndexMaterial: {
      type: Number as PropType<number>,
    },
    typeModalHeader: {
      type: String as PropType<string>,
      default: "",
    },
    isAdaptativeLearning: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    user(): User {
      return getUserFromStorage();
    },
  },
  data() {
    return {
      loading: false as boolean,
      _typeModalHeader: TypeModalHeader,
    };
  },
  methods: {
    getLearningGroupTypePT(learningGroup: string): string {
      let result = "";
      if (learningGroup === MaterialLearningGroupType.INTRODUCTION) {
        result = "Introdução";
      } else if (learningGroup === MaterialLearningGroupType.MOTIVATION) {
        result = "Motivação";
      } else if (learningGroup === MaterialLearningGroupType.DEVELOPMENT) {
        result = "Desenvolvimento";
      } else if (learningGroup === MaterialLearningGroupType.CLOSURE) {
        result = "Fechamento";
      }
      return result;
    },
    getMaterialTypePT(materialType: string): string {
      let result = "";
      if (materialType === MaterialType.ESSENTIAL) {
        result = "Essencial";
      } else if (materialType === MaterialType.COMPLEMENTARY) {
        result = "Complementar";
      }
      return result;
    },
    onChooseMaterial(value: number): void {
      this.$emit("onChooseMaterial", value);
    },
    onGoToEditObject(): void {
      this.$emit("onGoToEditObject");
    },
    onDeleteObject() {
      this.loading = true;
      this.$emit("onDeleteObject");
    },
  },
});
</script>
